import React, { useCallback } from 'react';
import clsx from 'clsx';
import { AbstractProvider } from 'web3-core';
import ThreeDotsLoader from '../Icons/ThreeDotsLoader';
import { getSupportedWallets } from '../../services/providerService';
import './styles.scss';

interface IWalletProviders {
  handleConnect: (provider: AbstractProvider) => void
  connecting: boolean | string
}

const WalletProviders: React.FC<IWalletProviders> = ({ handleConnect, connecting }) => {
  const supportedProviders = getSupportedWallets().filter((provider) => provider.enabled);
  const onClick = useCallback(({ currentTarget: { dataset } }) => {
    if (connecting !== dataset?.provider) {
      handleConnect(dataset?.provider);
    }
  }, [handleConnect, connecting]);

  return (
    <div className="web3-wc_connect-wallet-buttons-wrapper">
      {
        supportedProviders.map(({
          Icon, label, value, connectionType,
        }) => (
          <div
            key={label}
            className={clsx('web3-wc_wallet-wrapper', { [value]: value })}
            data-provider={connectionType}
            onClick={onClick}
          >
            <div className="wallet-name">{label}</div>
            {connecting === connectionType ? <ThreeDotsLoader /> : <Icon />}
          </div>
        ))
      }
    </div>
  );
};

export default WalletProviders;
